import { lazy } from "react";

export const NewCoursePage = lazy(() => import("./newCoursePage"));
